import type { FaireProductEntity } from "../../entity_types/product";

export const p_tse9ygx6fp: FaireProductEntity = {
  token: "p_tse9ygx6fp",
  type: "product",
  name: "Guava ginger beer",
  brandToken: "b_kumd7c4ksq",
  brandName: "Ginger Lab",
  imageUrl:
    "https://cdn.faire.com/fastly/7ddc1c54e111279c9ec4491e5bab6ed06e8cac0652fae6f5a1da00d17858fc90.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/20ce94c87d7ee28dc791dd955d1341c8423dd46f30aa06aab87962b811b13f9b.jpeg",
    "https://cdn.faire.com/fastly/e1bd5477d66faab69ecbc8530342fdfb7f632b911b74344d5a33c02a65ada40f.jpeg",
    "https://cdn.faire.com/fastly/d0d96fe8ab93acc5cff66cc7676db92972c0cac2d49dfafd4e47163d31b74ef2.jpeg",
    "https://cdn.faire.com/fastly/b6d512ef4e14c78ac6518c0807fed45bd00ed2f1c687874a7cd4cea835637197.jpeg",
  ],
  priceDollars: 5.33,
  description:
    "A Ginger Lab and customer favorite, our Guava brew transports you to Hawaii with each sip. Because our ginger beers are made from fresh ginger, there is a spicy kick to it — you can add more sparkling water to tamp down the intensity. Enjoy these ginger beers on their own, or craft a cocktail with vodka, whiskey, rum, prosecco, pisco etc.! Each bottle contains 12oz of non-alcoholic ginger beer, made from fresh ginger and lemon. No preservatives or flavor extracts are added.\n\nINGREDIENTS:\nGinger, Lemon juice, Guava puree, Organic cane sugar, Carbonated water, Fruits and vegetables for color",
  tags: [],
  msrpDollars: 8.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:10.844Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
